import {Component, OnInit} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {FormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {SafeResourcePipe, AuthService, LocalService} from "lib-base";
import {AuthenticationManagerService} from "../../../services/authentication-manager.service";
import {NgClass, NgIf} from "@angular/common";
import {
  IContainerAsideComponent, IReplaceTextTraslate,
} from "../../../shared/interfaces/configuracion";
import {firstValueFrom, forkJoin, Subscription} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {MasterAsideService} from "../../../services/aside/master-aside.service";

@Component({
  selector: 'app-aside-public',
  standalone: true,
  imports: [
    ButtonDirective,
    FormsModule,
    InputTextModule,
    NgIf,
    SafeResourcePipe,
    NgClass
  ],
  templateUrl: './aside-public.component.html',
  styleUrl: './aside-public.component.scss'
})
export class AsidePublicComponent implements OnInit {
  translations: any = {};
  cardContent: IContainerAsideComponent[] = [];
  loginSubscription !: Subscription;
  logoutSubscription !: Subscription;

  constructor(private _am: AuthenticationManagerService, private _ls: LocalService,
              private _router: Router, private _as: AuthService,
              private asideService : MasterAsideService,
              private _translate: TranslateService) {
  }



  ngOnInit(): void {
    this.getTraslations();
    this.loginSubscription = this._as.loginSource$.subscribe(key => {
      this.initCardContent();
    });
    this.logoutSubscription = this._as.logoutSource$.subscribe(key => {
      this.initCardContent();
    });
  }

  private async getTraslations(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      ingresoPortal: this._translate.get('components.app-aside-pub.ingreso-portal'),
      descripcionIngresoPortal: this._translate.get('components.app-aside-pub.descripcion-ingreso-portal'),
      labelBtn: this._translate.get('components.app-aside-pub.label-btn-ingreso-portal'),
      registroUser: this._translate.get('components.app-aside-pub.titulo-registro-user'),
      registrese: this._translate.get('components.app-aside-pub.registrese'),
      descripcionRegistrese: this._translate.get('components.app-aside-pub.descripcion-registrese'),
      primeraVez: this._translate.get('components.app-aside-pub.primera-vez'),
      firma: this._translate.get('components.app-aside-pub.get-firma'),
      descripcionFirma: this._translate.get('components.app-aside-pub.descripcion-firma'),
      estadoTramites: this._translate.get('components.app-pub-topbar.estado-tramites'),
      estadoTramiteDescripcion: this._translate.get('components.app-aside-pub.descripcion-mis-tramites'),
      labelBtnEstadoTram:this._translate.get('form.button.ver'),
      descripicionSeccion: this._translate.get('components.app-aside-pub.titulo-registro-user'),
      misPagos: this._translate.get('common.misPagos'),
      verMisPagos: this._translate.get('components.app-aside-pub.ver-mis-pagos'),
      misPagosDescripcion: this._translate.get('components.app-aside-pub.descripcion-mis-pagos'),
      misFacturas: this._translate.get('common.misFacturas'),
      verMisFacturas: this._translate.get('components.app-aside-pub.ver-mis-facturas'),
      misFacturaDescripcion: this._translate.get('components.app-aside-pub.descripcion-mis-facturas'),
    }));
    this.initCardContent();
  }

  initCardContent() {
    const props = {
      redirect: (route: string) => this.redirect(route),
      handlerInputSideBar: (index: number) => this.handlerInputSideBar(index)
    }
    const privateItems = this.asideService.getMenuItems(this.translations,this._ls.isLoggedIn, props )
    const commonItems = this.commonItems();
    this.cardContent = [...commonItems,...privateItems ];
  }

  private commonItems(): IContainerAsideComponent[] {

    let text1 = this.replacePairText(this.translations.descripcionRegistrese,
      {target: '${', value: '<span class="text-blue-general">'},
      {target: '}', value: '</span>'});
    let text2 = this.replacePairText(this.translations.descripcionFirma,
      {target: '${', value: ' <a class="text-blue-general">'},
      {target: '}', value: '</a>'});
    return [
      {
        visible: !this._ls.isLoggedIn,
        items: [{
          index: 0,
          title: this.translations.ingresoPortal,
          content: this.translations.descripcionIngresoPortal,
          buttonLabel: this.translations.labelBtn,
          icon: 'pi pi-sign-in',
          command: (event: any) => this.handlerInputSideBar(0),
        }]
      },
      {
        visible: !this._ls.isLoggedIn,
        class: 'mt-3',
        items: [{
          index: 1,
          title: this.translations.registrese,
          html: `
        <p class="mt-0 app-text-gray font-12 line-height-3">
         ${text1}
        </p>`,
          descripcionCard: this.translations.registroUser,
          command: (event: any) => this.handlerInputSideBar(1)
        },
          {
            index: 2,
            title: this.translations.firma,
            html: `<p class="mt-0 app-text-gray font-12 line-height-3">
                ${text2}
          </p>`,
            descripcionCard:this.translations.primeraVez
          }]
      },
      {
        visible: this._ls.isLoggedIn,
        items: [
          {
            index: 0,
            icon: 'pi pi-eye',
            title: this.translations.estadoTramites,
            content: this.translations.estadoTramiteDescripcion,
            buttonLabel: this.translations.labelBtnEstadoTram,
            command: (event: any) => this.redirect('/tramites/estado-tramite'),
          }
        ]
      },
    ];
  }

  redirect(route:string){
    this._router.navigate([route]).then();
  }

  handlerInputSideBar(index: number) {
    this._am.onOpenTab(index)
  }

  replacePairText(text:string, first:IReplaceTextTraslate, second:IReplaceTextTraslate):string {
    const textCopy = this.findAndReplaceText(text,first.target, first.value);
    return this.findAndReplaceText(textCopy, second.target, second.value);
  }

  private findAndReplaceText(text: string, target: string, value: string): string {
    return text.replaceAll(target, value);
  }
}
